export default {
  data: function () {
    return {
      _isVisible: false,
      _isEnter: false
    }
  },
  methods: {

    onScrollUpdate (position) {
      let rect = this.$el.getBoundingClientRect()
      let p = -rect.y / (rect.height - window.innerHeight)
      let pv = -(rect.y - window.innerHeight) / (rect.height + window.innerHeight)

      let isEnter = p > 0 && p < 1
      let isVisible = pv > 0 && pv < 1
      if (isVisible && !this._isVisible) { this._isVisible = true; this.onVisible() }
      if (!isVisible && this._isVisible) { this._isVisible = false; this.onUnVisible() }
      if (isEnter && !this._isEnter) { this._isEnter = true; this.onEnter() }
      if (!isEnter && this._isEnter) { this._isEnter = false; this.onExit() }

      p = Math.min(1, Math.max(0, p))
      pv = Math.min(1, Math.max(0, pv))
      this.onProgress(p, pv)
    },
    onProgress (p, pv) {
    },
    onVisible () {

    },
    onUnVisible () {

    },
    onEnter () {

    },
    onExit () {

    }
  },
  mounted () {
    this.$parallax.getInstance().on('update', this.onScrollUpdate)
  },
  beforeDestroy () {
    this.$parallax.getInstance().off('update', this.onScrollUpdate)
  }
}
